import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { List, ListItem, ListItemIcon, ListItemText } from '@material-ui/core/'
import ExitToAppOutlinedIcon from '@material-ui/icons/ExitToAppOutlined'
import { makeStyles } from '@material-ui/core/styles'
import { useHistory } from 'react-router-dom'
import clsx from 'clsx'
import noop from 'lodash/noop'
import Switch from '../molecules/Switch'
import SummitOnlyContent from '../atoms/SummitOnlyContent'
import FlexRow from '../molecules/FlexRow'
import { useToggleThemeType } from '../../hooks/useThemeType'
import { LOCAL_STORAGE_KEYS } from '../../constants'
import { localStorageHelper } from '../../utils/localStorageHelper'

const useStyles = makeStyles((theme) => ({
  link: {
    padding: '0px'
  },
  item: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4)
  }
}))

function Profile ({ closeProfileNav }) {
  const classes = useStyles()
  const history = useHistory()

  const signOut = useCallback(() => {
    closeProfileNav()
    localStorageHelper.removeItems(Object.values(LOCAL_STORAGE_KEYS))
    history.replace('/logout')
  }, [closeProfileNav, history])
  const [themeType, toggleThemeType] = useToggleThemeType()

  return (
    <List>
      <ListItem
        component='a'
        button
        className={clsx(classes.link, classes.item)}
        key='profileLink-1'
        href='/preferences'
      >
        <ListItemText primary='Preferences' />
      </ListItem>
      <SummitOnlyContent>
        <ListItem
          className={clsx(classes.link, classes.item)}
          key='toggleDarkMode'
        >
          <FlexRow>
            <div>Dark Mode</div>
            <Switch checked={themeType === 'dark'} onChange={toggleThemeType} />
          </FlexRow>
        </ListItem>
      </SummitOnlyContent>
      <ListItem
        button
        onClick={signOut}
        className={clsx(classes.link, classes.item)}
      >
        <ListItemIcon style={{ minWidth: '32px' }}>
          <ExitToAppOutlinedIcon />
        </ListItemIcon>
        <ListItemText primary='Logout' />
      </ListItem>
    </List>
  )
}

Profile.propTypes = {
  closeProfileNav: PropTypes.func
}

Profile.defaultProps = {
  closeProfileNav: noop
}

export default Profile
